/* eslint-disable no-unused-vars */
const applications_cols = [
  'apps',
  'pba_number',
  'pl_type',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const applications_placements_cols = [
  'apps',
  'placement_id',
  'placement',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const date_cols = ['date', 'impressions', 'clicks', 'installs', 'ctr', 'earning', 'eCPM'];
const country_cols = [
  'country',
  'country_code',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const country_placements_cols = [
  'country',
  'placement_id',
  'placement',
  'country_code',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const placement_cols = [
  'placement',
  'pl_type',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const placement_country_cols = [
  'placement',
  'placement_id',
  'country',
  'country_code',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];
const advertiser_cols = [
  'advertiser',
  'placement_id',
  'adveriser_id',
  'campaigns',
  'campaigns_names',
  'impressions',
  'clicks',
  'installs',
  'ctr',
  'earning',
  'eCPM',
];

const percentageMetrics = ['ctr', 'cr'];
const TEXT_PREFIX = '\u200C';

const formatNumber = (value, options = {}) => {
  if (!value) return 0;
  return Number(value).toLocaleString('en-US', options);
};

export const downloadCSV = (data, filename, type) => {
  const csvContent = convertToCSV(data, type);

  const utf8BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([utf8BOM, csvContent], { type: 'text/csv;charset=UTF-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

function convertToCSV(objArray, type) {
  if (!objArray || !type) return;
  let array = typeof objArray !== 'object' ? JSON.parse(objArray) : structuredClone(objArray);

  let csv = '';
  let columns;
  switch (type) {
    case 'applications':
      columns = applications_cols;
      break;
    case 'applications_placements':
      columns = applications_placements_cols;
      array = unwrapSubElements(array);
      break;
    case 'date':
      columns = date_cols;
      break;
    case 'country':
      columns = country_cols;
      break;
    case 'country_placements':
      columns = country_placements_cols;
      array = unwrapSubElements(array);
      break;
    case 'placement':
      columns = placement_cols;
      break;
    case 'placement_country':
      columns = placement_country_cols;
      array = unwrapSubElements(array);
      break;
    case 'advertiser':
      columns = advertiser_cols;
      break;
  }

  const formatedHeaders = columns.map((header) => {
    let newHeader = header;
    switch (header) {
      case 'cr':
        newHeader = 'CR';
        break;
      case 'ctr':
        newHeader = 'CTR';
        break;
      case 'eCPM':
        newHeader = 'eCPM';
        break;
      case 'pba_number':
        newHeader = 'App ID';
        break;
      case 'pl_type':
        newHeader = 'Platform';
        break;
      case 'placement_id':
        newHeader = 'Placement ID';
        break;
      case 'country_code':
        newHeader = 'Country Code';
        break;
      case 'adveriser_id':
        newHeader = 'Advertiser ID';
        break;
      case 'campaigns':
        newHeader = 'Campaigns ID';
        break;
      case 'campaigns_names':
        newHeader = 'Campaigns';
        break;
      default:
        newHeader = header.charAt(0).toUpperCase() + header.slice(1);
    }

    return newHeader;
  });
  csv += formatedHeaders.join(',') + '\n';

  const formatedArray = array.map((item) => {
    const formatedItem = {};

    // select props and add symbols
    columns.forEach((column) => {
      if (column === 'earning') {
        formatedItem[column] =
          '$' +
          formatNumber(item[column], {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
      } else if (column === 'eCPM') {
        // TO-DO track down why there is eCPM1 (3841ca03 commit)
        const value = item[column] || item.eCPM1;
        const formattedValue = formatNumber(value, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        });
        // TO-DO check why .csv fails 3 decimal for that page (but not for manage campaigns)
        formatedItem[column] = `${TEXT_PREFIX}${formattedValue}`;
      } else if (percentageMetrics.includes(column)) {
        formatedItem[column] =
          formatNumber(item[column], {
            maximumFractionDigits: 2,
          }) + '%';
      } else if (column === 'placement') {
        formatedItem[column] = item.placement + ' - ' + item.apps;
      } else if (column === 'campaigns') {
        formatedItem[column] = item.campaigns.split(',').join(' ,');
      } else if (typeof item[column] === 'number' && column !== 'pba_number') {
        formatedItem[column] = formatNumber(item[column]);
      } else {
        formatedItem[column] = item[column];
      }
    });

    return formatedItem;
  });

  // data rows
  for (const row of formatedArray) {
    const values = columns.map((header) => {
      const escaped = String(row[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csv += values.join(',') + '\n';
  }

  return csv;
}

function unwrapSubElements(array) {
  const result = [];
  array.forEach((item) => {
    if (item.subElements && Array.isArray(item.subElements)) {
      result.push(...unwrapSubElements(item.subElements));
    } else {
      result.push(item);
    }
  });

  return result;
}
